import { render, staticRenderFns } from "./procurement-guidelines.html?vue&type=template&id=26eb052f&scoped=true&external"
import script from "./procurement-guidelines.js?vue&type=script&lang=js&external"
export * from "./procurement-guidelines.js?vue&type=script&lang=js&external"
import style0 from "./procurement-guidelines.scss?vue&type=style&index=0&id=26eb052f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eb052f",
  null
  
)

export default component.exports